module.exports = __webpack_public_path__ + "img/back-rounded.2e9fd42.svg";